import { render } from "./ContactForMinutesSubscription.vue?vue&type=template&id=f73789cc&scoped=true"
import script from "./ContactForMinutesSubscription.vue?vue&type=script&lang=js"
export * from "./ContactForMinutesSubscription.vue?vue&type=script&lang=js"

import "./ContactForMinutesSubscription.vue?vue&type=style&index=0&id=f73789cc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f73789cc"]])

export default __exports__